// Engineering-only escape hatch for the brand → new-buyer-app handoff.
// Set in the browser console: localStorage.setItem(SKIP_NEW_BUYER_APP_REDIRECT_KEY, "true").
// Lets us exercise the legacy in-app paths even after the feature flag is on.
//
// Imported directly from "./isDevMode" rather than the "@/utils" barrel —
// devFlags is itself re-exported from the barrel, so going through it would
// create a cycle.
import { isProduction } from "./isDevMode";

export const SKIP_NEW_BUYER_APP_REDIRECT_KEY = "dev:skipNewBuyerAppRedirect";

export const shouldSkipNewBuyerAppRedirect = (): boolean => {
    // Hard-gate to non-production. The right way to disable the redirect for
    // real users is the feature flag itself; this localStorage bypass must
    // never be reachable from a prod build, even with the key set.
    if (isProduction) return false;
    try {
        return localStorage.getItem(SKIP_NEW_BUYER_APP_REDIRECT_KEY) === "true";
    } catch {
        return false;
    }
};
